/**
 * @param {string} path
 * @returns {Boolean}
 */
export function isExternal(path) {
    return /^(https?:|mailto:|tel:)/.test(path)
}

/**
 * 获取上个月时间戳
 * @returns 
 */
export function getlastMonth() {
    let now = new Date();
    // 当前月的日期
    let nowDate = now.getDate();
    let lastMonth = new Date(now.getTime());
    // 设置上一个月（这里不需要减1）
    lastMonth.setMonth(lastMonth.getMonth());
    // 设置为0，默认为当前月的最后一天
    lastMonth.setDate(0);
    // 上一个月的天数
    let daysOflastMonth = lastMonth.getDate();
    // 设置上一个月的日期，如果当前月的日期大于上个月的总天数，则为最后一天 
    lastMonth.setDate(nowDate > daysOflastMonth ? daysOflastMonth : nowDate);
    return lastMonth;
}


/**
 * 按指定月份进行计算
 * @returns 
 */
export function getMonth(year,month,last_month_num) {
    let now = new Date();
    //设置时间 
    now.setFullYear(year);
    now.setDate(1);
    now.setMonth(month);
    let last_year;
    let last_month;
    if(month == 1){
        last_month_num -= 1;
        last_month = 12-last_month_num;
        last_year = year - 1;
    }else{
        last_month = month - last_month_num;
        last_year = year;
    }
    let day = new Date();
    day.setFullYear(last_year);
    day.setDate(1);
    day.setMonth(last_month);
    return day;
}

